/* Interruptor "Protección de envío" del carrito (Olga Ricci).
   Añade o quita el producto proteccion-de-envio (2,50 €) del carrito
   y vuelve a pintar el carrito para que el total se actualice. */
(() => {
  if (customElements.get('shipping-protection')) return;

  const HANDLE = 'proteccion-de-envio';
  const r = window.routes || {};
  const ADD_URL = (r.cart_add_url || '/cart/add') + '.js';
  const CHANGE_URL = (r.cart_change_url || '/cart/change') + '.js';
  const CART_URL = (r.cart_url || '/cart') + '.js';
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const post = (url, data) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).then((res) => res.json());

  const onCartPage = () => /\/cart\/?$/.test(window.location.pathname);

  async function refreshBubble() {
    try {
      const res = await fetch(ROOT + '?sections=cart-icon-bubble').then((r) => r.json());
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !res['cart-icon-bubble']) return;
      const html = new DOMParser().parseFromString(res['cart-icon-bubble'], 'text/html');
      const source = html.querySelector('.shopify-section') || html.body;
      bubble.innerHTML = source.innerHTML;
    } catch (e) {
      console.error(e);
    }
  }

  async function refreshCart() {
    if (onCartPage()) {
      window.location.reload();
      return;
    }
    const items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') {
      await items.onCartUpdate();
    }
    await refreshBubble();
  }

  // Si en el carrito solo queda la protección (sin productos), se quita sola.
  async function removeOrphan(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    const lines = cart.items.filter((item) => item.handle === HANDLE);
    if (!lines.length || lines.length !== cart.items.length) return;
    for (const line of lines) {
      await post(CHANGE_URL, { id: line.key, quantity: 0 });
    }
    await refreshCart();
  }

  class ShippingProtection extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const input = this.querySelector('input');
      if (input) input.addEventListener('change', () => this.toggle(input.checked));
    }

    async toggle(on) {
      this.classList.add('is-loading');
      try {
        if (on) {
          await post(ADD_URL, { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] });
        } else {
          const id = this.dataset.lineKey || Number(this.dataset.variantId);
          await post(CHANGE_URL, { id, quantity: 0 });
        }
      } catch (e) {
        console.error(e);
      }
      await refreshCart();
      this.classList.remove('is-loading');
    }
  }

  customElements.define('shipping-protection', ShippingProtection);

  function init() {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.cartData && Array.isArray(event.cartData.items)) removeOrphan(event.cartData);
      });
    }
    const state = window.spState || {};
    if (state.orphan) {
      fetch(CART_URL).then((r) => r.json()).then(removeOrphan).catch(() => {});
    } else if (state.inCart) {
      // El contador del icono del carrito no debe contar la protección.
      refreshBubble();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
